import {ComponentElementPropertyType} from "../ComponentElementManifest.model";
import {FormContentConditionName} from "../../form/FormContent.model";
import {LookUpPreventActionType} from "../../data_set/LookUp.model";

export enum CallGridAction {
    ADD = "Add",
    UPDATE = "Update",
    DETAIL = "Detail",
    EDIT = "TableInlineEdit",
    CUSTOM = "Custom",
}

export enum CallGridActionLabel {
    EDIT = "Table Inline Edit"
}

export enum DoGridAction {
    ADD = "Add",
    UPDATE = "Update",
    DELETE = "Delete",
    RELOAD = "Reload",
    CANCEL = "Cancel",
    RESET = "Reset",
    RETRIEVE = "Retrieve",
    CUSTOM = "Custom"
}

export enum DoRetrieve {
    RELOADRETRIEVE = "ReloadRetrieve"
}

export enum DoGridSearchAction {
    RESET = "Reset",
    SEARCH = "Search",
    RETRIEVE = "Retrieve"
}

export const GridIdKeyConstant = "gridId";
export const GridIdConstant = {
    label: "",
    description: "",
    value: "",
    type: ComponentElementPropertyType._INTERNAL
};

export const GridLinkIdKeyConstant = "gridLinkId";
export const GridLinkIdConstant = {
    label: "Grid Link ID",
    description: "Connect with between Grid Action",
    value: "",
    type: ComponentElementPropertyType.INPUT
};

export const GridOpenActionKeyConstant = "gridOpenAction";
export const GridOpenActionConstant = {
    label: "Grid Open Actions",
    description: "Grid Open Action by Action Caller (example: CallAdd, CallUpdate, (CallCustom)Move)",
    value: [],
    type: ComponentElementPropertyType.CHIPS
};

export const GridApplyActionKeyConstant = "gridApplyAction";
export const GridApplyActionConstant = {
    label: "Grid Apply Actions",
    description: "Grid Apply Action by Action Runner (example: RunAdd, RunUpdate, (RunCustom)Move)",
    value: [],
    type: ComponentElementPropertyType.CHIPS
};

export const GridCloseActionKeyConstant = "gridCloseAction";
export const GridCloseActionConstant = {
    label: "Grid Close Actions",
    description: "Grid Close Action by Action Runner (example: RunCancel, (RunCustom)Cancel)",
    value: [],
    type: ComponentElementPropertyType.CHIPS
};

export const GridRetrieveKeyConstant = "gridRetrieve";
export const GridRetrieveConstant = {
    label: "Retrieve",
    description: "Used as a Retrieve Data Container",
    value: false,
    type: ComponentElementPropertyType.BOOLEAN
};

export const GridActionKeyConstant = "gridAction";
export const GridActionConstant = {
    label: "Grid Action",
    description: "Grid Action",
    value: "",
    type: ComponentElementPropertyType.GRIDACTION
};

export const GridDoSearchConstant = {
    label: "Grid Action",
    description: "Grid Action",
    value: DoGridSearchAction.SEARCH,
    type: ComponentElementPropertyType.GRIDACTION
};

export const GridDoRetrieveConstant = {
    label: "Grid Action",
    description: "Grid Action",
    value: DoGridSearchAction.RETRIEVE,
    type: ComponentElementPropertyType.GRIDACTION
};

export const GridDoResetConstant = {
    label: "Grid Action",
    description: "Grid Action",
    value: DoGridSearchAction.RESET,
    type: ComponentElementPropertyType.GRIDACTION
};

export const GridValidationKeyConstant = "validation";
export const GridValidationConstant = {
    label: "Validation",
    description: "Auto Validation when clicking",
    value: true,
    type: ComponentElementPropertyType.BOOLEAN
};

export const GridAutoCloseKeyConstant = "autoClose";
export const GridAutoCloseConstant = {
    label: "Auto Close",
    description: "Auto close after success if possible",
    value: true,
    type: ComponentElementPropertyType.BOOLEAN
};

export const GridAutoSaveKeyConstant = "autoSave";
export const GridAutoSaveConstant = {
    label: "Auto Save",
    description: "Auto save before reload",
    value: true,
    type: ComponentElementPropertyType.BOOLEAN
};

export const GridNoItemMessageKeyConstant = "noItem";
export const GridNoItemMessageConstant = {
    label: "No Item Message",
    description: "Message if there are no items to update",
    value: "",
    type: ComponentElementPropertyType.INPUT,
    i18n: true
};

export const GridConfirmKeyConstant = "confirm";
export const GridConfirmConstant = {
    label: "Confirm Message",
    description: "Confirm Message before action",
    value: "",
    type: ComponentElementPropertyType.INPUT,
    i18n: true
};

export const GridSuccessKeyConstant = "success";
export const GridSuccessConstant = {
    label: "Success Message",
    description: "Success Message after success",
    value: "",
    type: ComponentElementPropertyType.INPUT,
    i18n: true
};

export const GridNoItemKeyConstant = "noItem";
export const GridNoItemConstant = {
    label: "No Item Message",
    description: "No Item Message",
    value: "",
    type: ComponentElementPropertyType.INPUT,
    i18n: true
};

export const GridOnlyOneKeyConstant = "onlyOne";
export const GridOnlyOneConstant = {
    label: "Only One Message",
    description: "Message if selected action is not possible due to multiple selection",
    value: "",
    type: ComponentElementPropertyType.INPUT,
    i18n: true
};

export const GridClientPagingKeyConstant = "clientPaging";
export const GridClientPagingConstant = {
    label: "Client Paging",
    description: "Client Paging",
    value: false,
    type: ComponentElementPropertyType.BOOLEAN
};

export const GridClientPagingSizeKeyConstant = "clientPagingSize";
export const GridClientPagingSizeConstant = {
    label: "Client Paging Max Size",
    description: "Client Paging Max Size",
    value: "",
    type: ComponentElementPropertyType.INPUTINTEGER,
    limit: {allowNegative: false}
};

/** Prevent Click or Context Menu in Grid */
export const GridPreventClickKeyConstant = "___preventClick";
export const GridPreventClickConstant = {
    label: "Prevent Click in Grid",
    description: "Prevent click event in grid",
    value: [FormContentConditionName.EDITABLE, FormContentConditionName.VISIBILITYHIDDEN],
    lookUpData: LookUpPreventActionType,
    lookUpMultiple: true,
    type: ComponentElementPropertyType.MULTIPLESELECT
};
export const GridPreventContextKeyConstant = "___preventContext";
export const GridPreventContextConstant = {
    label: "Prevent Context in Grid",
    description: "Prevent context menu event in grid",
    value: [FormContentConditionName.VISIBILITYHIDDEN],
    lookUpData: LookUpPreventActionType,
    lookUpMultiple: true,
    type: ComponentElementPropertyType.MULTIPLESELECT
};

/** Validation when to complete */
export const GridValidationForCompleteKeyConstant = "___validationForComplete";
export const GridValidationForCompleteConstant = {
    label: "Validation For Complete",
    description: "Validation when to complete under editable of this component's condition",
    value: null,
    type: ComponentElementPropertyType.GRIDVALIDATIONFORCOMPLETE
};

/** for custom */
export const CustomValidationForCompleteConstant = {
    label: "Validation For Complete",
    description: "Validation when to complete",
    value: null,
    type: ComponentElementPropertyType.CUSTOMVALIDATIONFORCOMPLETE
};
